import { motion } from "framer-motion";
import {
    Briefcase,
    Cpu,
    Megaphone,
    Landmark,
    Flame,
    Dumbbell,
    Code2,
    Rocket,
    Target,
    Brain,
    Timer,
    Laptop,
    TrendingUp,
    IndianRupee,
    MessagesSquare,
    GraduationCap,
} from "lucide-react";
import SectionHeading from "./SectionHeading";

const CATEGORIES = [
    { icon: Briefcase, name: "Business", count: "1,200+" },
    { icon: Cpu, name: "Artificial Intelligence", count: "1,500+" },
    { icon: Megaphone, name: "Digital Marketing", count: "1,100+" },
    { icon: Landmark, name: "Finance & Investing", count: "950+" },
    { icon: Flame, name: "Self-Improvement", count: "1,400+" },
    { icon: Dumbbell, name: "Health & Fitness", count: "800+" },
    { icon: Code2, name: "Programming & Tech", count: "1,300+" },
    { icon: Rocket, name: "Entrepreneurship", count: "900+" },
    { icon: Target, name: "Sales", count: "750+" },
    { icon: Brain, name: "Psychology", count: "650+" },
    { icon: Timer, name: "Productivity", count: "850+" },
    { icon: Laptop, name: "Freelancing", count: "700+" },
    { icon: TrendingUp, name: "Stock Market & Trading", count: "900+" },
    { icon: IndianRupee, name: "Personal Finance", count: "800+" },
    { icon: MessagesSquare, name: "Communication Skills", count: "600+" },
    { icon: GraduationCap, name: "Career & Education", count: "600+" },
];

export default function Categories() {
    return (
        <section
            id="categories"
            data-testid="categories-grid"
            className="scroll-mt-24 py-16 sm:py-24"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <SectionHeading
                    eyebrow="Inside the bundle"
                    title="16+ categories. One tiny payment."
                    sub="From boardrooms to brain science — whatever you want to learn next, it's already in here."
                />
                <div className="mt-10 grid grid-cols-2 gap-3 sm:gap-5 md:grid-cols-3 lg:grid-cols-4">
                    {CATEGORIES.map(({ icon: Icon, name, count }, i) => (
                        <motion.div
                            key={name}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{
                                duration: 0.45,
                                delay: (i % 4) * 0.06,
                            }}
                            data-testid="category-card"
                            className="group rounded-2xl border border-emerald-100 bg-white p-4 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-orange-200 hover:shadow-[0_20px_40px_-15px_rgba(234,88,12,0.25)] sm:p-6"
                        >
                            <span className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600 transition-colors duration-300 group-hover:bg-orange-500 group-hover:text-white sm:h-11 sm:w-11">
                                <Icon size={20} />
                            </span>
                            <h3 className="font-display text-sm font-bold text-slate-900 sm:text-base">
                                {name}
                            </h3>
                            <p className="mt-0.5 text-xs text-slate-500 sm:text-sm">
                                {count} eBooks
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
